import { gql } from 'apollo-angular';

export const moduleColumns = gql`
	fragment ModuleColumns on ModuleColumnOutput {
		id
		position
		updateTimestamp
		localizations {
			name
			locale
		}
	}
`;
